/**
 * Styles for `ValuationsTableHead/` (resize handle, etc.).
 * `ValuationsTableHead.tsx` is a pass-through to `GenericTableHead` — no extra styles there.
 */
import { Box, styled } from '@mui/material';
import { DASHBOARD_DARK } from 'theme/dashboardDarkPalette';

/** Hit area for column resize (Valuations table header) */
const StyledResizeHandleContainer = styled(Box)(() => ({
  width: '16px',
  height: '100%',
  cursor: 'col-resize',
  position: 'absolute',
  right: 0,
  top: '50%',
  transform: 'translateY(-50%)',
  display: 'flex',
  alignItems: 'center',
  zIndex: 1,
}));

/** Vertical grip — light: secondary text; dark: matches table row border (`$tableBodyCellBorderDark`) */
const StyledResizeHandleGrip = styled(Box)(({ theme }) => ({
  width: '2px',
  height: '80%',
  margin: '0 auto',
  backgroundColor:
    theme.palette.mode === 'dark' ? DASHBOARD_DARK.tableBodyCellBorderDark : theme.palette.text.secondary,
}));

export { StyledResizeHandleContainer, StyledResizeHandleGrip };
